import { createAction, props } from '@ngrx/store';
import { PaymentsPolicyResponse, PaymentsTransactionResponse } from '../../model/payments.model';
import AppError from '../../model/app-error';

export enum PaymentsActions {
  Reset = '[Payments] Reset',
  ResetOnInit = '[Payments] Reset on init',
  ResetOnStatus = '[Payments] Reset on status',
  FetchTransactionStart = '[Payments] Fetch Transaction Start',
  FetchTransactionSuccess = '[Payments] Fetch Transaction Success',
  FetchTransactionError = '[Payments] Fetch Transaction Error',
  FetchPolicyStart = '[Payments] Fetch Policy Start',
  FetchPolicySuccess = '[Payments] Fetch Policy Success',
  FetchPolicyError = '[Payments] Fetch Policy Error',
}

const reset = createAction(PaymentsActions.Reset);
const resetOnInit = createAction(PaymentsActions.ResetOnInit);
const resetOnStatus = createAction(PaymentsActions.ResetOnStatus);
const fetchTransactionStart = createAction(PaymentsActions.FetchTransactionStart, props<{ transactionGUID: string }>());
const fetchTransactionSuccess = createAction(PaymentsActions.FetchTransactionSuccess, props<{ success: PaymentsTransactionResponse }>());
const fetchTransactionError = createAction(PaymentsActions.FetchTransactionError, props<{ error: AppError | null }>());
const fetchPolicyStart = createAction(PaymentsActions.FetchPolicyStart, props<{ hashCode?: string }>());
const fetchPolicySuccess = createAction(PaymentsActions.FetchPolicySuccess, props<{ success: PaymentsPolicyResponse }>());
const fetchPolicyError = createAction(PaymentsActions.FetchPolicyError, props<{ error: AppError }>());

const paymentsActions = {
  reset,
  resetOnInit,
  resetOnStatus,
  fetchTransactionStart,
  fetchTransactionSuccess,
  fetchTransactionError,
  fetchPolicyStart,
  fetchPolicySuccess,
  fetchPolicyError,
};

export default paymentsActions;
